import { take } from "lodash";

export const getAllNotifications = (state) => state.notifications;
export const getVisibleNotifications = (state) => take(getAllNotifications(state), 3);
